import { SinglePlanNotice } from "../single-plan/SinglePlanNotice";

/** Growth is the single plan: there is nothing to upgrade to. */
export function SettingsBillingUpgrade() {
  return <SinglePlanNotice />;
}
